import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface ProtectedRouteProps {
  // You can add more props here if needed, e.g., roles
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = () => {
  const token = localStorage.getItem('authToken');

  if (!token) {
    // User not authenticated, redirect to login page
    return <Navigate to="/login" replace />;
  }

  // User is authenticated, render the child routes
  // Outlet is used by react-router-dom to render nested routes
  return <Outlet />;
};

export default ProtectedRoute;
